(function($) {$(document).ready(function() {

	let timer = null;
	let maxIndex = 0;

	$('.stories-pop__arrow.left, .stories-pop__m-left').on('click', () => $('.stories-pop__slides').flickity('previous'));
	$('.stories-pop__arrow.right, .stories-pop__m-right').on('click', () => $('.stories-pop__slides').flickity('next'));

	$('.stories-pop').on('click', event => {
		if (event.target === event.currentTarget) close();
	});

	$('.visual-stories__item').on('click', open);
	$('.stories-pop__close').on('click', close);

	function updateTab(index) {
		$('.stories-pop__tab').removeClass('active complete');

		// Timeout to Force repaint and css transitions to reset
		setTimeout(() => {
			// Mobile
			$('.stories-pop__tabs--m .stories-pop__tab').eq(index)
				.addClass('active')
				.prevAll()
				.addClass('complete');
			// Desktop
			$('.stories-pop__tabs--d .stories-pop__tab').eq(index)
				.addClass('active')
				.prevAll()
				.addClass('complete');
		}, 5);
	}

	function updateArrows(index) {
		$('.stories-pop__arrow').removeClass('disabled');

		if (index === 0) $('.stories-pop__arrow.left').addClass('disabled');
		if (index === maxIndex) $('.stories-pop__arrow.right').addClass('disabled');
	}

	function restartTimer() {
		clearTimeout(timer);
		timer = setTimeout(gotoNext, 4000);
	}

	function gotoNext() {
		$('.stories-pop__slides').flickity('next');
	}

	function open(event) {
		const $this = $(this);

		// gather data
		const slideData = $this.find('.visual-stories__data > *').map((index, el) => {
			return {img: el.getAttribute('data-img'), label: el.getAttribute('data-label')};
		}).toArray();
		const date = $this.find('.visual-stories__date').text();
		const title = $this.find('.visual-stories__title').text();

		maxIndex = slideData.length - 1;

		// make slide markup
		const slideMarkup = slideData.map(data => `
			<div class="stories-pop__slide" style="background-image: url(${data.img});">
				<img src="${data.img}" alt="">
				<div class="stories-pop__img-label"><span>${data.label}</span></div>
			</div>`
		);
		
		$('.stories-pop__slides').html(slideMarkup);

		// make tabs
		const tabMarkup = slideData.map(data => '<div class="stories-pop__tab"></div>');
		$('.stories-pop__tabs').html(tabMarkup);

		// populate date and title
		$('.stories-pop__date').text(date);
		$('.stories-pop__title').text(title);

		flickitySetup();

		// Show
		$('.stories-pop').addClass('open');
		
		// Make sure flickity is sized correctly
		$('.stories-pop__slides').flickity('select', 0).flickity('resize');
		
		updateTab(0);
		updateArrows(0);
		restartTimer();
	}

	function close() {
		clearTimeout(timer);
		$('.stories-pop').removeClass('open');
		$('.stories-pop__slides').flickity('destroy');
	}

	function flickitySetup() {
		$('.stories-pop__slides').flickity({
			imagesLoaded: true,
			cellAlign: 'center',
			prevNextButtons: false,
			pageDots: false,
			cellSelector: '.stories-pop__slide',
			on: {
				change: index => {
					updateTab(index);
					updateArrows(index);
					restartTimer();
				}
			},
			draggable: window.innerWidth >= 1024
		});
	}

});;jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);